import * as z from "zod";

export const getTrackingPageGlobalSettings = {
  name: "getTrackingPageGlobalSettings" as const,
  input: z.object({}),
  output: z.object({ loadingBackgroundColor: z.string().optional() }),
};
